import React from 'react';
import 'twin.macro';
import { buildDiffKey } from './utils';
import { LivretEleveDiff } from './types';
import _isEmpty from 'lodash-es/isEmpty';
import { DiffCheckbox } from './CheckboxWrapper';

interface Props {
  diff: LivretEleveDiff;
  onSelect: () => void;
  isSelected: boolean;
}

export function SyncDiffTableRowBilan({ diff, onSelect, isSelected }: Props) {
  const rowKey = buildDiffKey(diff);
  return (
    <tr key={rowKey}>
      <td tw="relative p-3">
        <DiffCheckbox isSelected={isSelected} onSelect={onSelect} />
      </td>
      <td tw="p-3">{diff.matiere}</td>
      <td colSpan={3} tw="p-3">
        {!_isEmpty(diff.bilan) && (
          <div tw="flex items-center">
            <span tw="text-xs text-success mr-2">(+ Ajout)</span>
            <span tw="text-success font-semibold">{diff.bilan || ''}</span>
          </div>
        )}
      </td>
    </tr>
  );
}
